class CustomDropdown extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details.custom-dropdown");
    if (!this.mainDetailsToggle) return;

    this.summary = this.mainDetailsToggle.querySelector(
      "summary.custom-dropdown"
    );
    this.content = this.summary.nextElementSibling;

    // Handle toggle event for animation and arrow rotation
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));

    // Manage click on summary to toggle aria-expanded manually
    this.summary.addEventListener("click", (event) => {
      // Allow clicking on the <a> to follow link; only manage arrow toggle if clicked outside <a>
      if (event.target.tagName.toLowerCase() === "a") return;

      event.preventDefault(); // Prevent default toggle behavior on summary, manual handled below

      const expanded = this.summary.getAttribute("aria-expanded") === "true";
      this.summary.setAttribute("aria-expanded", String(!expanded));
      if (expanded) {
        this.close();
      } else {
        this.open();
      }
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
      this.summary.classList.add("arrow-rotated");
    } else {
      this.animations.forEach((animation) => animation.cancel());
      this.summary.classList.remove("arrow-rotated");
    }
  }

  open() {
    this.mainDetailsToggle.setAttribute("open", "");
    this.summary.setAttribute("aria-expanded", "true");
    this.onToggle();
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.summary.setAttribute("aria-expanded", "false");
    this.onToggle();
  }
}

customElements.define("custom-dropdown-wrapper", CustomDropdown);
